module.exports = __webpack_public_path__ + "img/cvp1.aae00253.png";